// This context updates svg symbols loaded through the fontawesome script, for linkage through ECLThemeImage
import React, { createContext, useState } from "react";

export const FAContext = createContext();

export function FAContextProvider(props) {
   const [icons, setIcons] = useState([]);

   function updateIcons(icon) {
      setIcons((i) => [...new Set([...i, icon])]);
   }

   return (
      <FAContext.Provider value={updateIcons}>
         {icons.map((i) => {
            return (
               <i
                  data-fa-symbol={"fa-symbol-" + i}
                  className={`fa-solid fa-${i}`}
                  key={i}
               ></i>
            );
         })}
         {props.children}
      </FAContext.Provider>
   );
}
